import { useEffect, useState } from 'react'
import { ReportService, ErrorConstant } from 'utility'

export const useReportPermissions = () => {
    const [permissions, setPermissions] = useState({
        hasCumulativeReport: false,
    })
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')

    const fetchPermissions = async () => {
        try {
            setLoading(true)
            const result = await ReportService.getCustomReportTypes()
            console.log('Report Types Response:', result)
            const hasCumulative = Array.isArray(result)
                ? result.some(report => report.ReportId === 3)
                : result?.ReportId === 3
            console.log('Has Cumulative Report:', hasCumulative)
            setPermissions({ hasCumulativeReport: hasCumulative })
        } catch (error) {
            console.error('Error fetching report permissions:', error)
            setError(error.message || ErrorConstant.default)
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        fetchPermissions()
    }, [])

    return { permissions, loading, error, refresh: fetchPermissions }
}
